var _CUSTOM_COD_FORM_PROVINCES = {
  data:{"CIUDAD AUTONOMA DE BUENOS AIRES": {
    "AGRONOMÍA": {
      "1417": true,
      "1419": true,
      "1427": true,
      "1431": true
    },
    "ALMAGRO": {
      "1172": true,
      "1200": true,
      "1247": true
    },
    "BALVANERA": {
      "1020": true,
      "1022": true,
      "1025": true,
      "1026": true,
      "1027": true,
      "1028": true,
      "1029": true,
      "1030": true,
      "1031": true,
      "1032": true,
      "1033": true,
      "1034": true,
      "1036": true,
      "1039": true,
      "1040": true,
      "1044": true,
      "1045": true,
      "1046": true,
      "1066": true,
      "1104": true,
      "1110": true
    },
    "BARRACAS": {
      "1138": true,
      "1139": true,
      "1140": true,
      "1141": true,
      "1143": true,
      "1152": true,
      "1153": true,
      "1164": true,
      "1255": true,
      "1260": true,
      "1265": true,
      "1267": true,
      "1268": true,
      "1269": true,
      "1424": true,
      "1425": true,
      "1426": true
    },
    "BELGRANO": {
      "1218": true,
      "1220": true,
      "1221": true,
      "1428": true,
      "1429": true,
      "1430": true
    },
    "BOEDO": {
      "1184": true,
      "1226": true,
      "1228": true,
      "1230": true,
      "1231": true,
      "1232": true,
      "1233": true,
      "1235": true,
      "1236": true,
      "1237": true,
      "1238": true,
      "1239": true,
      "1240": true,
      "1241": true,
      "1250": true,
      "1257": true,
      "1405": true,
      "1406": true
    },
    "CABALLITO": {
      "1414": true,
      "1416": true,
      "1418": true,
      "1424": true,
      "1427": true
    },
    "CHACARITA": {
      "1428": true,
      "1429": true,
      "1430": true,
      "1431": true
    },
    "COGHLAN": {
      "1414": true,
      "1426": true,
      "1427": true,
      "1428": true
    },
    "COLEGIALES": {
      "1070": true,
      "1071": true,
      "1072": true,
      "1073": true
    },
    "CONSTITUCIÓN": {
      "1074": true,
      "1075": true,
      "1076": true,
      "1077": true,
      "1080": true,
      "1099": true,
      "1100": true,
      "1101": true,
      "1102": true,
      "1103": true,
      "1107": true,
      "1110": true,
      "1130": true,
      "1133": true,
      "1406": true,
      "1407": true,
      "1416": true,
      "1417": true
    },
    "FLORES": {
      "1406": true,
      "1407": true,
      "1416": true,
      "1419": true,
      "1424": true,
      "1437": true
    },
    "FLORESTA": {
      "1063": true,
      "1065": true,
      "1155": true,
      "1157": true,
      "1440": true
    },
    "LA BOCA": {
      "1158": true,
      "1160": true,
      "1161": true,
      "1162": true,
      "1163": true,
      "1164": true,
      "1165": true,
      "1166": true,
      "1167": true,
      "1169": true,
      "1185": true,
      "1265": true,
      "1266": true,
      "1407": true,
      "1408": true,
      "1440": true
    },
    "LINIERS": {
      "1407": true,
      "1439": true,
      "1440": true
    },
    "MATADEROS": {
      "1408": true,
      "1416": true,
      "1417": true
    },
    "MONTE CASTRO": {
      "1000": true,
      "1002": true,
      "1010": true,
      "1014": true,
      "1419": true
    },
    "MONTSERRAT": {
      "1020": true,
      "1033": true,
      "1041": true,
      "1063": true,
      "1064": true,
      "1065": true,
      "1066": true,
      "1067": true,
      "1068": true,
      "1069": true,
      "1070": true,
      "1071": true,
      "1072": true,
      "1263": true,
      "1428": true,
      "1429": true,
      "1436": true,
      "1437": true
    },
    "NUEVA POMPEYA": {
      "1004": true,
      "1007": true,
      "1019": true,
      "1429": true
    },
    "NUÑEZ": {
      "1055": true,
      "1113": true
    },
    "PALERMO": {
      "1172": true,
      "1175": true,
      "1176": true,
      "1177": true,
      "1179": true,
      "1180": true,
      "1181": true,
      "1182": true,
      "1183": true,
      "1186": true,
      "1188": true,
      "1238": true,
      "1406": true,
      "1407": true,
      "1414": true,
      "1416": true,
      "1425": true,
      "1439": true,
      "1440": true
    },
    "PARQUE AVELLANEDA": {
      "1250": true,
      "1406": true,
      "1424": true,
      "1437": true
    },
    "PARQUE CHACABUCO": {
      "1234": true,
      "1241": true,
      "1243": true,
      "1427": true,
      "1431": true
    },
    "PARQUE CHAS": {
      "1244": true,
      "1245": true
    },
    "PARQUE PATRICIOS": {
      "1000": true,
      "1001": true,
      "1247": true,
      "1249": true,
      "1254": true,
      "1256": true,
      "1258": true,
      "1259": true,
      "1260": true,
      "1261": true,
      "1262": true,
      "1263": true,
      "1264": true,
      "1416": true,
      "1417": true,
      "1427": true
    },
    "PATERNAL": {
      "1005": true,
      "1006": true,
      "1007": true
    },
    "PUERTO MADERO": {
      "1000": true,
      "1001": true,
      "1010": true,
      "1011": true,
      "1012": true,
      "1013": true,
      "1184": true,
      "1425": true
    },
    "RECOLETA": {
      "1001": true,
      "1004": true,
      "1005": true,
      "1006": true,
      "1007": true,
      "1014": true,
      "1015": true,
      "1016": true,
      "1018": true,
      "1019": true,
      "1020": true,
      "1021": true,
      "1022": true,
      "1025": true
    },
    "RETIRO": {
      "1008": true,
      "1009": true,
      "1010": true,
      "1011": true,
      "1012": true,
      "1013": true,
      "1014": true,
      "1016": true,
      "1021": true,
      "1025": true,
      "1054": true,
      "1055": true,
      "1057": true,
      "1080": true,
      "1428": true,
      "1429": true,
      "1430": true,
      "1431": true
    },
    "SAAVEDRA": {
      "1099": true,
      "1133": true,
      "1151": true,
      "1219": true
    },
    "SAN CRISTÓBAL": {
      "1001": true,
      "1002": true,
      "1003": true,
      "1004": true,
      "1005": true,
      "1220": true,
      "1221": true,
      "1222": true,
      "1223": true,
      "1224": true,
      "1225": true,
      "1227": true,
      "1229": true,
      "1230": true,
      "1231": true,
      "1232": true
    },
    "SAN NICOLÁS": {
      "1006": true,
      "1007": true,
      "1008": true,
      "1009": true,
      "1010": true,
      "1011": true,
      "1012": true,
      "1013": true,
      "1014": true,
      "1015": true,
      "1016": true,
      "1063": true,
      "1064": true,
      "1065": true,
      "1066": true,
      "1068": true
    },
    "SAN TELMO": {
      "1069": true,
      "1086": true,
      "1091": true,
      "1098": true,
      "1099": true,
      "1100": true,
      "1101": true,
      "1102": true,
      "1103": true,
      "1107": true,
      "1114": true,
      "1140": true,
      "1141": true,
      "1143": true,
      "1183": true,
      "1189": true,
      "1407": true
    },
    "VERSALLES": {
      "1405": true,
      "1414": true
    },
    "VILLA CRESPO": {
      "1158": true,
      "1406": true,
      "1416": true,
      "1417": true,
      "1419": true,
      "1425": true
    },
    "VILLA DEVOTO": {
      "1417": true,
      "1425": true
    },
    "VILLA GENERAL MITRE": {
      "1407": true,
      "1408": true,
      "1416": true,
      "1429": true,
      "1439": true
    },
    "VILLA LUGANO": {
      "1427": true,
      "1440": true
    },
    "VILLA LURO": {
      "1419": true,
      "1425": true,
      "1430": true,
      "1431": true
    },
    "VILLA ORTÚZAR": {
      "1006": true,
      "1408": true,
      "1431": true
    },
    "VILLA PUEYRREDÓN": {
      "1414": true,
      "1417": true,
      "1419": true
    },
    "VILLA REAL": {
      "1223": true,
      "1407": true,
      "1416": true,
      "1417": true,
      "1439": true
    },
    "VILLA RIACHUELO": {
      "1419": true
    },
    "VILLA SANTA RITA": {
      "1406": true,
      "1407": true,
      "1427": true,
      "1428": true,
      "1437": true
    },
    "VILLA SOLDATI": {
      "1084": true,
      "1430": true,
      "1431": true
    },
    "VILLA URQUIZA": {
      "1407": true,
      "1414": true,
      "1416": true
    }
  },
  "BUENOS AIRES (PROVINCIA)": {
    "VILLA PORVENIR": {
      "1870": true
    },
    "VILLA NUÑEZ": {
      "1874": true
    },
    "SARANDI": {
      "1872": true
    },
    "WILDE ESTE": {
      "1875": true
    },
    "VILLA REBASA": {
      "1752": true
    },
    "VILLA DON BOSCO": {
      "1704": true
    },
    "BARRIO ALMAFUERTE (TABLADA-PDO. LA MATANZA)": {
      "1766": true
    },
    "VILLA MADERO": {
      "1768": true
    },
    "MONTE CHINGOLO": {
      "1825": true
    },
    "VILLA JARDIN": {
      "1822": true
    },
    "VILLA POMPEO": {
      "1826": true
    },
    "VILLA INDUSTRIALES": {
      "1824": true
    },
    "VILLA centenario": {
      "1828": true
    },
    "VILLA HENZ": {
      "1836": true
    },
    "VILLA RITA": {
      "1832": true
    },
    "TEMPERLEY": {
      "1834": true
    },
    "BARRIO SAN JOSE (PDO. LOMAS DE ZAMORA)": {
      "1835": true
    },
    "FIORITO": {
      "1831": true
    },
    "VILLA ALBERTINA": {
      "1829": true
    },
    "VILLA URBANA": {
      "1773": true
    },
    "VILLA MARIA DE LOS REMEDIOS DE ESCALADA": {
      "1657": true
    },
    "VILLA LANZONI": {
      "1655": true
    },
    "VILLA MAIPU": {
      "1650": true
    },
    "VILLA ZAGALA": {
      "1651": true
    },
    "VILLA LYNCH (PDO. GRAL. SAN MARTIN)": {
      "1672": true
    },
    "VILLA BALLESTER": {
      "1653": true
    },
    "VILLA PARQUE": {
      "1678": true
    },
    "VILLA JOSE INGENIEROS": {
      "1702": true
    },
    "VILLA TALLERES ALIANZA": {
      "1676": true
    },
    "VILLA BOSCH": {
      "1682": true
    },
    "VILLA SAENZ PEÑA": {
      "1674": true
    },
    "EL PALOMAR": {
      "1684": true
    },
    "PUENTE SAAVEDRA": {
      "1602": true
    },
    "OLIVOS": {
      "1636": true
    },
    "CARAPACHAY": {
      "1606": true
    },
    "MUNRO": {
      "1605": true
    },
    "VICENTE LOPEZ": {
      "1638": true
    },
    "VILLA MARTELLI": {
      "1603": true
    },
    "JOSE MARMOL": {
      "1844": true,
      "1846": true
    },
    "VILLA PARIS": {
      "1856": true
    },
    "MINISTRO RIVADAVIA": {
      "1852": true
    },
    "VILLA LAURA (RAFAEL CALZADA-PDO. ALMTE. BROWN)": {
      "1847": true
    },
    "LONGCHAMPS": {
      "1854": true
    },
    "CLAYPOLE": {
      "1849": true
    },
    "VILLA SOL": {
      "1884": true
    },
    "RUTA 2 KILOMETRO 32 AL 36,900": {
      "1890": true
    },
    "VILLA REAL": {
      "1885": true
    },
    "VILLA GIAMBRUNO": {
      "1886": true
    },
    "RUTA 2 KILOMETRO 44,500": {
      "1893": true
    },
    "VILLA TRANSRADIO": {
      "1776": true
    },
    "MONTE GRANDE": {
      "1841": true,
      "1842": true,
      "1851": true
    },
    "VILLA PARISH ROBERTSON": {
      "1838": true
    },
    "VILLA VALLIER": {
      "1625": true
    },
    "RUTA 26 MAQUINISTA FRANCISCO SAVIO": {
      "1619": true
    },
    "PUNTA DE CANAL (APEADERO FCGM)": {
      "1623": true
    },
    "MAQUINISTA FRANCISCO SAVIO": {
      "1620": true
    },
    "ZELAYA": {
      "1627": true
    },
    "COLONIA LOS CHIVATOS": {
      "1802": true
    },
    "VILLA GUILLERMINA": {
      "1804": true
    },
    "TRISTAN SUAREZ": {
      "1806": true
    },
    "Carlos Spegazzini": {
      "1812": true
    },
    "VILLA VATTEONE": {
      "1888": true
    },
    "VILLA HUDSON": {
      "1889": true
    },
    "INGENIERO ALLAN": {
      "1891": true
    },
    "WILLIAMS C. MORRIS (PARADA FCGSM)": {
      "1686": true
    },
    "TESEI": {
      "1688": true
    },
    "VILLA BARRIO ALTUBE": {
      "1665": true
    },
    "VILLA SANTA JULIA": {
      "1761": true
    },
    "TAPIALES": {
      "1770": true
    },
    "VILLA UNION": {
      "1757": true
    },
    "VILLA SCASSO": {
      "1759": true
    },
    "VIRREY DEL PINO": {
      "1763": true,
      "1764": true
    },
    "VILLA SAN ALBERTO": {
      "1765": true
    },
    "VILLA CELINA": {
      "1767": true,
      "1772": true
    },
    "QUERANDI": {
      "1778": true
    },
    "RAFAEL CASTILLO": {
      "1755": true
    },
    "LA SALADA": {
      "1774": true
    },
    "MERCADO CENTRAL": {
      "1771": true
    },
    "VILLA LUZURIAGA": {
      "1753": true,
      "1754": true
    },
    "KILOMETRO 30": {
      "1612": true
    },
    "TORTUGUITAS": {
      "1667": true
    },
    "KILOMETRO 38 (PDO. GRAL. SARMIENTO)": {
      "1615": true
    },
    "YAPEYU": {
      "1613": true
    },
    "VILLA DE MAYO": {
      "1614": true
    },
    "VILLA LAGO DEL BOSQUE": {
      "1722": true
    },
    "RUTA 200 KILOMETRO 38": {
      "1723": true
    },
    "VILLA MAGDALENA": {
      "1716": true
    },
    "SAN ANTONIO DE PADUA": {
      "1718": true
    },
    "VILLA ESCOBAR": {
      "1746": true
    },
    "VILLA MONSEGUR": {
      "1744": true
    },
    "VILLA GRAL. ZAPIOLA": {
      "1742": true
    },
    "TRUJUI": {
      "1664": true,
      "1736": true
    },
    "MORON": {
      "1482": true,
      "1708": true
    },
    "CASTELAR": {
      "1710": true,
      "1712": true
    },
    "MARIANO J. HAEDO": {
      "1706": true
    },
    "VILLA VERDE": {
      "1629": true
    },
    "VILLA DEL CARMEN (DEL VISO-PDO. GRAL. SARMIENTO)": {
      "1669": true
    },
    "VILLA ASTOLFI": {
      "1633": true
    },
    "TORO": {
      "1635": true
    },
    "VILLA ROSA": {
      "1630": true,
      "1631": true
    },
    "VILLA LA FLORIDA": {
      "1881": true
    },
    "QUILMES OESTE": {
      "1879": true
    },
    "EZPELETA": {
      "1882": true
    },
    "VILLA MARIA (QUILMES-PDO. QUILMES)": {
      "1878": true
    },
    "DON BOSCO": {
      "1876": true,
      "1877": true
    },
    "ZANJA TAMAGNI": {
      "1649": true
    },
    "VIRREYES": {
      "1646": true
    },
    "VICTORIA": {
      "1644": true
    },
    "MARTINEZ": {
      "1640": true
    },
    "SAN ISIDRO": {
      "1642": true
    },
    "VILLA ADELINA": {
      "1607": true
    },
    "BECCAR": {
      "1643": true
    },
    "BOULOGNE SUR MER": {
      "1609": true
    },
    "SAN MIGUEL": {
      "1663": true
    },
    "ESCUELA SUBOFICIALES SARGENTO CABRAL (APEADERO FCGU)": {
      "1659": true
    },
    "TENIENTE GRAL. RICCHIERI": {
      "1661": true
    },
    "VILLA LAS TUNAS": {
      "1617": true
    },
    "DON TORCUATO": {
      "1611": true
    },
    "BENAVIDEZ": {
      "1621": true
    },
    "EL TALAR": {
      "1618": true
    },
    "NORDELTA": {
      "1666": true,
      "1670": true,
      "1671": true
    },
    "VILLA LA ÑATA": {
      "1648": true
    },
    "LOS TALAS": {
      "1923": true
    },
    "ISLA SANTIAGO": {
      "1929": true
    },
    "LA HORQUETA (PDO. CAMPANA)": {
      "2805": true
    },
    "RUTA 9 KILOMETRO 72": {
      "2804": true
    },
    "PAVON": {
      "2812": true
    },
    "VICENTE CASARES": {
      "1808": true
    },
    "MAXIMO PAZ": {
      "1814": true
    },
    "VILLA ADRIANA": {
      "1816": true
    },
    "URIBELARREA": {
      "1815": true
    },
    "(EMBARCADERO FCGR) (ALTAMIRANO-PDO. GRAL. PAZ)": {
      "1986": true
    },
    "SAMBOROMBON": {
      "1980": true
    },
    "OLIDEN": {
      "1981": true
    },
    "GOMEZ DE LA VEGA": {
      "1983": true
    },
    "PUNTA LARA": {
      "1931": true
    },
    "PUERTO LA PLATA": {
      "1925": true
    },
    "ESCUELA NAVAL MILITAR RIO SANTIAGO": {
      "1927": true
    },
    "LOS CARDALES": {
      "2714": true,
      "2814": true
    },
    "SPERATTI": {
      "1741": true
    },
    "PARADA KILOMETRO 76": {
      "1739": true
    },
    "LA CHOZA": {
      "1737": true
    },
    "VILLARS": {
      "1731": true
    },
    "PUEBLO NUEVO (GRAL. RODRIGUEZ-PDO. GRAL. RODRIGUEZ)": {
      "1748": true
    },
    "SAN PONCIANO": {
      "1903": true
    },
    "RUTA 2 KILOMETRO 56 AL 64": {
      "1901": true
    },
    "IGNACIO CORREAS": {
      "1909": true
    },
    "LOS EUCALIPTOS": {
      "1895": true
    },
    "VILLA ELISA": {
      "1894": true
    },
    "RECREO VENECIA": {
      "1896": true
    },
    "TOLOSA": {
      "1900": true,
      "1906": true
    },
    "VILLA GARIBALDI": {
      "1907": true
    },
    "ISLA MARTIN GARCIA": {
      "1601": true
    },
    "POBLET": {
      "1905": true
    },
    "MANUEL B. GONNET": {
      "1897": true
    },
    "SANTA ELENA (LUJAN-PDO. LUJAN)": {
      "6700": true
    },
    "CARLOS KEEN": {
      "6701": true
    },
    "SUCRE": {
      "6708": true
    },
    "CORTINES": {
      "6712": true
    },
    "VILLA FRANCIA (VILLA FLANDRIA-PDO. LUJAN)": {
      "6706": true
    },
    "OLIVERA": {
      "6608": true
    },
    "ZAMUDIO (APEADERO FCDFS)": {
      "1727": true
    },
    "GUERNICA": {
      "1862": true
    },
    "VILLA NUMANCIA": {
      "1858": true
    },
    "EMPALME SAN VICENTE": {
      "1864": true
    },
    "HARAS RATAPLAN": {
      "1984": true
    },
    "SAN VICENTE": {
      "1865": true
    },
    "ESCALADA": {
      "2801": true
    },
    "ZARATE": {
      "2800": true
    },
    "RIO PARANA GUAZU": {
      "1647": true
    },
    "LIMA": {
      "2806": true
    },
    "RIO LUJAN (PDO. CAMPANA)": {
      "2802": true
    },
    "GERLI (PARTIDO AVELLANEDA)": {
      "1869": true
    },
    "Berazategui": {
      "1880": true
    },
    "ITUZAINGO": {
      "1714": true,
      "1715": true
    },
    "VILLA RAFFO": {
      "1675": true
    },
    "ACASSUSO": {
      "1641": true
    },
    "MUÑIZ": {
      "1662": true
    },
    "GONZALEZ CATAN": {
      "1758": true
    },
    "LA LUCILA": {
      "1637": true
    },
    "ALMIRANTE BROWN": {
      "1713": true,
      "1845": true,
      "1848": true
    },
    "DOMINGO FAUSTINO SARMIENTO": {
      "1707": true
    },
    "MARTIN CORONADO": {
      "1683": true
    },
    "SANTA ROSA": {
      "1867": true
    },
    "TRONCO DEL TALAR": {
      "1645": true
    },
    "CIUDADELA": {
      "1701": true
    },
    "9 DE ABRIL": {
      "1839": true
    },
    "LA REJA": {
      "1738": true
    },
    "BARRIO LA TABLADA": {
      "1751": true
    },
    "TIGRE": {
      "1610": true,
      "1622": true,
      "1703": true
    },
    "FRANCISCO ALVAREZ": {
      "1745": true
    },
    "RINCON DE MILBERG": {
      "1624": true
    },
    "Cuartel V": {
      "1740": true,
      "1762": true
    },
    "GRAND BOURG": {
      "1660": true,
      "1685": true
    },
    "FLORENCIO VARELA": {
      "1818": true,
      "1853": true,
      "1859": true,
      "1863": true,
      "1887": true
    },
    "el picaflor": {
      "1843": true
    },
    "Aturo Segui": {
      "1985": true
    },
    "el jaguel": {
      "1805": true
    },
    "Piñeyro": {
      "1868": true
    },
    "la plata": {
      "1902": true,
      "1904": true
    },
    "caning": {
      "1807": true
    },
    "Villa Elvira": {
      "1914": true
    },
    "SAN JUSTO": {
      "1785": true
    },
    "Ingeniero Budge": {
      "1827": true
    },
    "HURLINGHAM": {
      "1681": true,
      "1689": true
    },
    "gerli": {
      "1921": true
    },
    "MALVINAS ARGENTINAS": {
      "1616": true
    },
    "ESCOBAR": {
      "1628": true
    },
    "PILAR": {
      "1516": true,
      "1632": true,
      "1634": true,
      "1639": true
    },
    "TRES DE FEBRERO": {
      "1658": true,
      "1687": true
    },
    "DON ORIONE": {
      "1850": true
    },
    "CRUCECITA": {
      "1873": true
    },
    "SOURIGUES": {
      "1837": true
    },
    "BERISSO": {
      "1924": true
    },
    "CORONEL BRANDSEN": {
      "1918": true
    },
    "ENSENADA": {
      "1926": true
    },
    "HUNTER": {
      "2707": true
    },
    "FLAMENCO": {
      "2763": true
    },
    "LA UNION": {
      "1775": true
    },
    "EZEIZA": {
      "1801": true,
      "1803": true
    },
    "GENERAL LAS HERAS": {
      "1733": true
    },
    "GENERAL RODRIGUEZ": {
      "1747": true,
      "1749": true,
      "1750": true
    },
    "LA MATANZA": {
      "1756": true,
      "1769": true
    },
    "LA PLATA": {
      "1898": true,
      "1908": true,
      "1910": true,
      "1912": true,
      "1916": true
    },
    "LANUS": {
      "1823": true
    },
    "LOMAS DE ZAMORA": {
      "1833": true
    },
    "MERLO": {
      "1721": true,
      "1724": true
    },
    "MORENO": {
      "1743": true
    },
    "QUILMES": {
      "1840": true,
      "1855": true,
      "1883": true
    },
    "PLATANOS": {
      "1861": true
    },
    "BARRIO LOS TRONCOS DEL TALAR": {
      "1608": true
    },
    "BANFIELD": {
      "1821": true
    },
    "SAN MARTIN": {
      "1654": true
    },
    "BERAZATEGUI": {
      "1860": true
    },
    "LUJÁN": {
      "6700": true,
      "6702": true
    },
    "LUJAN": {
      "6709": true
    },
    "LUIS GUILLON": {
      "1777": true
    },
    "JOSÉ C. PAZ": {
      "1665": true
    },
    "MARCOS PAZ": {
      "1727": true
    },
    "CAMPANA": {
      "2804": true
    },
    "GENERAL SAN MARTÍN": {
      "1650": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}